import LabelView from './LabelView';
export default LabelView;
